module.exports = {
  filterAjaxList: [
    {
      url: '/api/label/brand/label',
      method: 'post',
      param: {},
      flagKey: 'brand',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/line/label',
      method: 'get',
      flagKey: 'lineName',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/platform/label',
      method: 'post',
      param: {},
      flagKey: 'platform',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/content/type/label',
      method: 'get',
      param: {},
      flagKey: 'contentType',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/scene/label',
      method: 'get',
      param: {},
      flagKey: 'scene',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/theme/label',
      method: 'get',
      param: {},
      flagKey: 'theme',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/cover/label',
      method: 'get',
      param: {},
      flagKey: 'cover',
      id: 'name',
      name: 'name'
    },
    // {
    //   url: '/api/label/total/cost/label',
    //   method: 'get',
    //   param: {},
    //   flagKey: 'totalCostLevel',
    //   id: 'name',
    //   name: 'name'
    // },
    // {
    //   url: '/api/label/cpe/label',
    //   method: 'get',
    //   param: {},
    //   flagKey: 'cpeCostLevel',
    //   id: 'name',
    //   name: 'name'
    // },
    // {
    //   url: '/api/label/cpv/label',
    //   method: 'get',
    //   param: {},
    //   flagKey: 'cpvCostLevel',
    //   id: 'name',
    //   name: 'name'
    // },
    // {
    //   url: '/api/label/follower/level/label',
    //   method: 'get',
    //   param: {},
    //   flagKey: 'followerLevel',
    //   id: 'name',
    //   name: 'name'
    // },
    {
      url: '/api/label/auth/circle/label',
      method: 'get',
      param: {},
      flagKey: 'authCircle',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/auth/level/label',
      method: 'get',
      param: {},
      flagKey: 'authLevel',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/depth/label',
      method: 'get',
      param: {},
      flagKey: 'depth',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/cooperate/type/label',
      method: 'get',
      param: {},
      flagKey: 'cooperateType',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/is/prereport/label',
      method: 'get',
      param: {},
      flagKey: 'isPrereport',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/area/label',
      method: 'get',
      param: {},
      flagKey: 'autoArea',
      id: 'name',
      name: 'name'
    }
  ],
  detailInfos: [
    {
      title: '内容信息',
      id: 'contentInfo',
      updateType: 1, // 更新类型后端保存接口需要用到
      initWidth: '50',
      isSaveLoading: false,
      infosList: [
        {
          key: 'title',
          label: '内容标题',
          isRequired: true,
          noInsert: true,
          placeholder: '请输入内容标题'
        }, {
          key: 'url',
          label: '发布链接',
          isRequired: true,
          placeholder: '请输入发布链接'
        }, {
          key: 'pubTime',
          label: '发布时间',
          type: 'date',
          dateType: 'datetime',
          valueFormat: 'yyyy-MM-dd HH:mm',
          relatedKey: 'pubDate'
        }, {
          key: 'pubDate',
          label: '发布日期',
          type: 'date',
          dateType: 'date',
          noInsert: true,
          valueFormat: 'yyyy-MM-dd'
        }, {
          key: 'platform',
          label: '平台',
          type: 'select'
        }, {
          key: 'brand',
          label: '品牌',
          type: 'select'
        }, {
          key: 'lineName',
          label: '产线',
          type: 'select'
        }, {
          key: 'lineType',
          label: '产品型号'
        }, {
          key: 'contentType',
          label: '内容类型',
          type: 'select'
        }, {
          key: 'theme',
          label: '内容选题',
          type: 'select'
        }, {
          key: 'cover',
          label: '内容封面',
          type: 'select'
        }, {
          key: 'scene',
          label: '内容场景',
          type: 'select'
        }, {
          key: 'sellPoint',
          label: '产品卖点'
        }, {
          key: 'productExposeRate',
          label: '产品露出',
          unit: '%',
          isParamAddUnit: true, // 保存时是否需要添加%
          regs: [
            {
              message: '请输入1-100，并且保留两位小数',
              reg: '/^(\\d{1,2}\\.(\\d{2})|100.00)$/'
            }
          ]
        }, {
          key: 'depth',
          label: '内容深度',
          type: 'select'
          // children: [
          //   {
          //     id: '0',
          //     name: '0'
          //   }, {
          //     id: '1',
          //     name: '1'
          //   }, {
          //     id: '2',
          //     name: '2'
          //   }, {
          //     id: '3',
          //     name: '3'
          //   }, {
          //     id: '4',
          //     name: '4'
          //   }, {
          //     id: '5',
          //     name: '5'
          //   }, {
          //     id: '6',
          //     name: '6'
          //   }, {
          //     id: '一般',
          //     name: '一般'
          //   }, {
          //     id: '提及',
          //     name: '提及'
          //   }, {
          //     id: '深度',
          //     name: '深度'
          //   }
          // ]
        }, {
          key: 'isPrereport',
          label: '是否报备',
          type: 'select'
          // children: [
          //   {
          //     id: '是',
          //     name: '是'
          //   }, {
          //     id: '否',
          //     name: '否'
          //   }, {
          //     id: '未知',
          //     name: '未知'
          //   }
          // ]
        }, {
          key: 'hasPersonalOpinion',
          label: '是否有个人使用后的经验',
          type: 'select',
          children: [
            {
              id: '是',
              name: '是'
            }, {
              id: '否',
              name: '否'
            }, {
              id: '未知',
              name: '未知'
            }
          ]
        }
      ]
    },
    {
      title: '互动信息',
      id: 'interactiveInfo',
      updateType: 2, // 更新类型后端保存接口需要用到
      initWidth: '50',
      isSaveLoading: false,
      infosList: [
        {
          key: 'exposeNum',
          label: '曝光数',
          regs: [
            {
              message: '请输入整数',
              reg: '/^[0-9]*$/'
            }
          ]
        }, {
          key: 'readNum',
          label: '阅读量',
          relatedKey: 'interactRate,cpvCost',
          regs: [
            {
              message: '请输入整数',
              reg: '/^[0-9]*$/'
            }
          ]
        }, {
          key: 'likeNum',
          label: '点赞量',
          relatedKey: 'interactNum',
          regs: [
            {
              message: '请输入整数',
              reg: '/^[0-9]*$/'
            }
          ]
        }, {
          key: 'subscribeNum',
          label: '收藏量',
          relatedKey: 'interactNum',
          regs: [
            {
              message: '请输入整数',
              reg: '/^[0-9]*$/'
            }
          ]
        }, {
          key: 'commentNum',
          label: '评论量',
          relatedKey: 'interactNum',
          regs: [
            {
              message: '请输入整数',
              reg: '/^[0-9]*$/'
            }
          ]
        }, {
          key: 'interactNum',
          label: '互动量',
          relatedKey: 'interactRate,cpeCost',
          noInsert: true
        }, {
          key: 'interactRate',
          label: '互动率',
          noInsert: true
        }, {
          key: 'finishRate',
          label: '完播率',
          unit: '%',
          isParamAddUnit: true, // 保存时是否需要添加%
          regs: [
            {
              message: '请输入1-100，并且保留两位小数',
              reg: '/^(\\d{1,2}\\.(\\d{2})|100.00)$/'
            }
          ]
        }, {
          key: 'isCollect',
          label: '是否收录',
          type: 'select',
          children: [
            {
              id: '是',
              name: '是'
            }, {
              id: '否',
              name: '否'
            }, {
              id: '未知',
              name: '未知'
            }
          ]
        }, {
          key: 'isPopular',
          label: '是否爆款',
          type: 'select',
          children: [
            {
              id: '是',
              name: '是'
            }, {
              id: '否',
              name: '否'
            }, {
              id: '未知',
              name: '未知'
            }
          ]
        }
      ]
    },
    {
      title: '达人信息',
      id: 'talentInfo',
      updateType: 3, // 更新类型后端保存接口需要用到
      initWidth: '50',
      isSaveLoading: false,
      infosList: [
        {
          key: 'authName',
          label: '达人名称'
        },
        {
          key: 'autoArea',
          label: '地区',
          type: 'tree',
          props: {
            value: 'id',
            label: 'name',
            expandTrigger: 'click',
            multiple: false,
            checkStrictly: true
          },
          placeholder: '可输入搜索选择',
          filterable: true,
          clearable: true
        },
        // {
        //   key: 'authCountry',
        //   label: '国家',
        //   type: 'select'
        // }, {
        //   key: 'authProvince',
        //   label: '省份',
        //   type: 'select'
        // }, {
        //   key: 'authCity',
        //   label: '城市',
        //   type: 'select'
        // },
        {
          key: 'follower',
          label: '粉丝数',
          relatedKey: 'followerLevel',
          regs: [
            {
              // message: '请输入有两位小数的数值',
              // reg: '/^\\d+(\\.\\d+)?$/'
              message: '请输入整数',
              reg: '/^[0-9]*$/'
            }
          ]
        }, {
          key: 'followerLevel',
          label: '粉丝量级',
          noInsert: true,
          children: [
            {
              min: 0,
              max: 10000,
              name: '<=1万'
            }, {
              min: 10000,
              max: 50000,
              name: '1-5万'
            }, {
              min: 50000,
              max: 100000,
              name: '5-10万'
            }, {
              min: 100000,
              max: 500000,
              name: '10-50万'
            }, {
              min: 500000,
              max: 5000000000000,
              name: '>50万'
            }
          ]
        }, {
          key: 'authLikeCollcet',
          label: '获赞与收藏量',
          regs: [
            {
              // message: '请输入有两位小数的数值',
              // reg: '/^\\d+(\\.\\d+)?$/'
              message: '请输入整数',
              reg: '/^[0-9]*$/'
            }
          ]
        }, {
          key: 'authLevel',
          label: '达人量级',
          type: 'select'
          // children: [
          //   {
          //     id: '1',
          //     name: '腿部'
          //   }, {
          //     id: '2',
          //     name: '腰部'
          //   }, {
          //     id: '3',
          //     name: '头部'
          //   }, {
          //     id: '4',
          //     name: '超头部'
          //   }, {
          //     id: '5',
          //     name: 'koc'
          //   }, {
          //     id: '6',
          //     name: '未知'
          //   }
          // ]
        }, {
          key: 'authCircle',
          label: '达人圈层',
          type: 'select'
        }, {
          key: 'cooperateType',
          label: '合作形式',
          type: 'select'
          // children: [
          //   {
          //     id: '1',
          //     name: '视频'
          //   }, {
          //     id: '2',
          //     name: '图文'
          //   }, {
          //     id: '3',
          //     name: '未知'
          //   }
          // ]
        }
      ]
    },
    {
      title: '费用成本',
      id: 'talentInfo',
      updateType: 4, // 更新类型后端保存接口需要用到
      initWidth: '50',
      isSaveLoading: false,
      infosList: [
        {
          key: 'searchCost',
          label: '搜索信息流花费(元)',
          relatedKey: 'totalCost',
          unit: '元',
          regs: [
            {
              message: '请输入有两位小数的数值',
              reg: '/^[0-9]+\\.(\\d{2})?$/'
            }
          ]
        }, {
          key: 'brandAdCost',
          label: '品牌广告花费(元)',
          relatedKey: 'totalCost',
          unit: '元',
          regs: [
            {
              message: '请输入有两位小数的数值',
              reg: '/^[0-9]+\\.(\\d{2})?$/'
            }
          ]
        }, {
          key: 'cooperateCost',
          label: '合作价格(元)',
          relatedKey: 'totalCost',
          unit: '元',
          regs: [
            {
              message: '请输入有两位小数的数值',
              reg: '/^[0-9]+\\.(\\d{2})?$/'
            }
          ]
        }, {
          key: 'totalCost',
          label: '费用成本(元)',
          relatedKey: 'cpeCost,cpvCost,totalCostLevel',
          noInsert: true,
          unit: '元',
          regs: [
            {
              message: '请输入有两位小数的数值',
              reg: '/^[0-9]+\\.(\\d{2})?$/'
            }
          ]
        }, {
          key: 'totalCostLevel',
          label: '费用成本层级',
          noInsert: true,
          children: [
            {
              min: 0,
              max: 1000,
              name: '≤1K元'
            }, {
              min: 1000,
              max: 5000,
              name: '1K-5K元'
            }, {
              min: 5000,
              max: 10000,
              name: '5K-1W元'
            }, {
              min: 10000,
              max: 100000,
              name: '1W-10W元'
            }, {
              min: 100000,
              max: 500000000000000000,
              name: '>10W元'
            }
          ]
        }, {
          key: 'cpeCost',
          label: 'CPE(元)',
          noInsert: true,
          relatedKey: 'cpeCostLevel'
        }, {
          key: 'cpeCostLevel',
          label: 'CPE层级',
          noInsert: true,
          children: [
            {
              min: 0,
              max: 10,
              name: '<=10元'
            }, {
              min: 10,
              max: 20,
              name: '10-20元'
            }, {
              min: 20,
              max: 50,
              name: '20-50元'
            }, {
              min: 50,
              max: 100,
              name: '50-100元'
            }, {
              min: 100,
              max: 50000000000000,
              name: '>100元'
            }
          ]
        }, {
          key: 'cpvCost',
          label: 'CPV(元)',
          noInsert: true,
          relatedKey: 'cpvCostLevel'
        }, {
          key: 'cpvCostLevel',
          label: 'CPV层级',
          noInsert: true,
          children: [
            {
              min: 0,
              max: 1,
              name: '<=1元'
            }, {
              min: 1,
              max: 2,
              name: '1-2元'
            }, {
              min: 2,
              max: 5,
              name: '2-5元'
            }, {
              min: 5,
              max: 10,
              name: '5-10元'
            }, {
              min: 10,
              max: 50000000000000,
              name: '>10元'
            }
          ]
        }
      ]
    }, {
      title: '评论信息',
      id: 'commentInfo',
      updateType: 5, // 更新类型后端保存接口需要用到
      initWidth: '50',
      isSaveLoading: false,
      infosList: [
        {
          key: 'positiveCommentNum',
          label: '我方正面及中性评论数',
          value: 0,
          regs: [
            {
              message: '请输入整数',
              reg: '/^[0-9]*$/'
            }
          ]
        }, {
          key: 'competitorPositiveCommentNum',
          label: '竞品正面及中性评论数',
          value: 0,
          regs: [
            {
              message: '请输入整数',
              reg: '/^[0-9]*$/'
            }
          ]
        }, {
          key: 'negativeCommentNum',
          label: '我方负面评论数',
          value: 0,
          regs: [
            {
              message: '请输入整数',
              reg: '/^[0-9]*$/'
            }
          ]
        }, {
          key: 'competitorNegativeCommentNum',
          label: '竞品负面评论数',
          value: 0,
          regs: [
            {
              message: '请输入整数',
              reg: '/^[0-9]*$/'
            }
          ]
        }, {
          key: 'commentKeyword',
          label: '讨论关键词'
        }
      ]
    }
  ]
}
